import React, { useEffect, useState } from "react"
import Modal from "aldoo-ra/Modal"
import Value, { getValue, setValue } from "aldoo-ra/Value"
import useT from "../hooks/useT"
import PlatformSelector from "./PlatformSelector"

const DIALOG_KEY = "sf-platform-dialog"

/**
 * Opens the "Select Your License" dialog for a license product.
 * onConfirm({ platform, licenses, universal }) receives the selection.
 */
export const openPlatformSelector = ({ product, initialDistribution, initialQuantity, confirmLabel, onConfirm }) =>
  setValue(DIALOG_KEY, { tick: (getValue(DIALOG_KEY)?.tick || 0) + 1, product, initialDistribution, initialQuantity, confirmLabel, onConfirm })

/** Mounted once (CheckoutHost); renders the dialog requested by openPlatformSelector */
export default function PlatformSelectorDialog() {
  const t = useT()
  const [request] = Value(DIALOG_KEY, null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (request?.tick) setOpen(true)
  }, [request?.tick])

  if (!request?.product) return null

  return (
    <Modal isOpen={open} onClose={() => setOpen(false)} variant="sf_dialog" title={t`Select Your License`} closeOnEscape>
      {open && (
        <PlatformSelector
          key={request.tick}
          product={request.product}
          initialDistribution={request.initialDistribution}
          initialQuantity={request.initialQuantity}
          confirmLabel={request.confirmLabel}
          onConfirm={(selection) => {
            setOpen(false)
            request.onConfirm?.(selection)
          }}
        />
      )}
    </Modal>
  )
}
